import { render, staticRenderFns } from "./PassRequisiton.vue?vue&type=template&id=0c8d97ad&scoped=true"
import script from "./PassRequisiton.vue?vue&type=script&lang=js"
export * from "./PassRequisiton.vue?vue&type=script&lang=js"
import style0 from "./PassRequisiton.vue?vue&type=style&index=0&id=0c8d97ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8d97ad",
  null
  
)

export default component.exports